var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("el-form", {
    staticStyle: {
      "margin-bottom": "-10px"
    },
    attrs: {
      inline: true
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "礼包ID"
    }
  }, [_c("el-input", {
    staticStyle: {
      width: "100px"
    },
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.data.coupon_id,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "coupon_id", $$v);
      },
      expression: "data.coupon_id"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "礼包名称"
    }
  }, [_c("el-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.data.coupon_name,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "coupon_name", $$v);
      },
      expression: "data.coupon_name"
    }
  })], 1), _c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.onGenerateBtn
    }
  }, [_vm._v(" 生成礼包码 ")])], 1)], 1), _c("el-table", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.tableData,
      border: "",
      "row-key": "authorityId",
      stripe: ""
    }
  }, [_c("el-table-column", {
    attrs: {
      label: "批次ID",
      prop: "batch",
      width: 80
    }
  }), _c("el-table-column", {
    attrs: {
      label: "备注",
      prop: "remark"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "礼包数量",
      prop: "code_count",
      width: 80
    }
  }), _c("el-table-column", {
    attrs: {
      label: "创建时间",
      prop: "create_time",
      width: 160
    }
  }), _c("el-table-column", {
    attrs: {
      label: "创建用户",
      width: 160
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(_vm.userInfoList[scope.row.create_user]) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "渠道"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var row = _ref.row;
        return [_vm._v(" " + _vm._s(_vm.getChannelDisplay(row.channel)) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "同步状态",
      width: 180
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var row = _ref2.row;
        return [row.sync_time > "1970-01-01 00:00:00" ? _c("el-tag", {
          attrs: {
            type: "success"
          }
        }, [_vm._v("已同步")]) : _c("el-tag", {
          staticStyle: {
            cursor: "pointer"
          },
          attrs: {
            type: "danger"
          },
          on: {
            click: function click($event) {
              return _vm.onSyncBtn(row);
            }
          }
        }, [_vm._v("同步失败（点击重试）")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "下载礼包码"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-button", {
          on: {
            click: function click($event) {
              return _vm.exportCoupon(scope.row.id);
            }
          }
        }, [_vm._v("下载礼包码")])];
      }
    }])
  })], 1), _c("div", {
    staticStyle: {
      display: "flex",
      "align-items": "center",
      "justify-content": "center"
    }
  }, [_c("el-pagination", {
    attrs: {
      "current-page": _vm.page,
      "page-size": _vm.pageSize,
      "page-sizes": [5, 10, 50, 100],
      total: _vm.total,
      layout: "total, sizes, prev, pager, next, jumper"
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };